export type CountFilter = {
  minCount?: number;
  maxCount?: number;
};

export enum CountFilterType {
  ANY = 'any',
  EXACTLY = 'exactly',
  BETWEEN = 'between',
}
